export const version: string = '1.0.74';
